import React from 'react';
import { toast } from 'react-hot-toast';
import { Bell } from 'lucide-react'; // 引入 Lucide 图标

// 更新通知的 JSX 组件
export const UpdateToast = ({ t, update }) => {
  return (
    <div className={`${t.visible ? 'animate-enter' : 'animate-leave'} 
                  max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto 
                  flex ring-1 ring-black ring-opacity-5 dark:bg-gray-800 dark:text-white`}>
      <div className="flex-1 p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0 pt-0.5">
            {/* 使用 Lucide 图标代替图片 */}
            <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center">
              <Bell className="h-6 w-6 text-indigo-600" />
            </div>
          </div>
          <div className="ml-3 flex-1">
            <p className="text-sm font-medium">
              {update.title}
            </p>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              {update.description}
            </p>
            <div className="mt-2 flex">
              <button
                onClick={() => {
                  toast.dismiss(t.id);
                  if (update.link) window.open(update.link, '_blank');
                }}
                className="text-sm font-medium text-indigo-600 hover:text-indigo-500 dark:text-indigo-400"
              >
                了解更多
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex border-l border-gray-200 dark:border-gray-700">
        <button
          onClick={() => toast.dismiss(t.id)}
          className="w-full flex items-center justify-center p-4 text-sm font-medium text-gray-700 hover:text-gray-500 dark:text-gray-300"
        >
          关闭
        </button>
      </div>
    </div>
  );
};

// 默认导出创建通知的函数
export default function createUpdateToast(t, update) {
  return <UpdateToast t={t} update={update} />;
}
